import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { AppSettings } from "../../../../app.settings";
import { Settings } from "../../../../app.settings.model";
import { MenuService } from "../menu.service";
import { SharedService } from "src/app/shared/shared.service";
 
@Component({
  selector: "app-vertical-menu",
  templateUrl: "./vertical-menu.component.html",
  styleUrls: ["./vertical-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
})
export class VerticalMenuComponent implements OnInit {
  @Input("menuItems") menuItems;
  @Input("menuParentId") menuParentId;
  parentMenu: Array<any>;
  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private sharedService: SharedService
  ) {
    this.settings = this.appSettings.settings;
  }
 
  ngOnInit() {
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    if (currentUser?.roles[0] === "ROLE_ADMIN") {
      this.parentMenu = this.menuItems.filter(
        (item) => item.parentId == this.menuParentId
      );
    } else {
      this.getpermissionDetails(currentUser?.roleId);
    }
  }
 
  onClick(menuId) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);
  }
 
  moduleList: any = [];
  getpermissionDetails(roleId) {
    this.sharedService.getModulePermssionByRoles(roleId).subscribe({
      next: (response) => {
        this.moduleList = response || [];
 
        // Step 1: Extract permitted titles from modules and submodules
        const permittedTitles: string[] = [];
 
        this.moduleList.data.forEach((module) => {
          if (module.visible) {
            permittedTitles.push(module.moduleName);
            if (module.subModules?.length) {
              module.subModules.forEach((sub) => {
                if (sub.subVisible) {
                  permittedTitles.push(sub.subModuleName);
                }
              });
            }
          }
        });
 
        // Step 2: Filter your original menuItems based on allowed titles
        this.menuItems = this.menuItems.filter((menu) =>
          permittedTitles.includes(menu.title)
        );
 
        // Step 3: Set current component's parent menu
        this.parentMenu = this.menuItems.filter(
          (item) => item.parentId === this.menuParentId
        );
      },
    });
  }
}